<template>
  <div class="chapter-preview-component">
    <Scroller
      :threshold=".5"
      :top="0"
      :bottom="1"
      v-on:index="index = $event.value"
      v-on:progress="progress = $event.value"
      v-on:offset="offset = $event.value"
      v-on:activeSections="activeSections = $event.value"
      v-on:direction="direction = $event.value"
    >
      <div ref="background" class="background">
        <div
          v-for="(section,  sectionIndex) in content"
          :key="'section-'+sectionIndex"
          :class="['chapter-preview']"
        >
          <transition name="chapter">
            <div :class="['chapter-preview-wrapper', direction]" v-if="index === sectionIndex">
              <div
                class="chapter-preview-image"
                :style="{backgroundImage: `url(${baseUrl}images/${currentContent.backgroundImage.name}${$retina ? '@2x' : ''}${$tvaMq === 'mobile' ? '_m' : ''}.jpg)`, backgroundPosition: `${currentContent.backgroundImage.backgroundPosition}`, backgroundSize: `${currentContent.backgroundImage.backgroundSize}%`}"
              ></div>
              <p
                v-if="currentContent.dida && $tvaMq === 'desktop'"
                class="dida"
                v-html="currentContent.dida"
              >{{currentContent.dida}}</p>
              <div class="chapter-preview-content">
                <div class="chapter-preview-index">{{currentContent.index}}</div>
                <router-link :to="{name: 'chapter', params: {chapterIndex: sectionIndex}}">
                  <div class="chapter-preview-title">
                    <span>0{{currentContent.index}}</span>
                    {{currentContent.title}}
                  </div>
                  <div class="chapter-preview-caption">
                    <span
                      v-for="(caption, captionIndex) in currentContent.caption"
                      :key="'caption-'+captionIndex"
                      :style="{transitionDelay: 0.05 * captionIndex + 's'}"
                    >{{caption}}</span>
                  </div>
                </router-link>

                <div class="chapter-preview-bullets">
                  <svgicon class="chapter-preview-icon" :icon="currentContent.img" height="70"></svgicon>
                  <div class="bullet-left">
                    <div
                      v-for="(bullet, bulletIndex) in currentContent.bulletsCaption"
                      :key="'bullet-left'+bulletIndex"
                      :style="{transitionDelay: 0.05 * bulletIndex + 's'}"
                      v-html="bullet"
                    >{{bullet}}</div>
                  </div>
                  <div class="bullet-right">
                    <div
                      v-for="(bullet, bulletIndex) in currentContent.bullets"
                      :key="'bullet-right'+bulletIndex"
                      :style="{transitionDelay: 0.05 * bulletIndex + 's'}"
                    >{{bullet}}</div>
                  </div>
                </div>
                <div class="leggi">
                  <router-link :to="{name: 'chapter', params: {chapterIndex: sectionIndex}}">
                    <div class="freccia">
                      <svgicon class="leggi-icon" icon="freccia" width="20" height="20"></svgicon>
                    </div>
                    {{$ml.get("landing").leggi}}
                  </router-link>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div ref="foreground">
        <div :class="['fake-section']" v-for="(section, index) in content" :key="index"></div>
      </div>
    </Scroller>
  </div>
</template>
<script>
import Scroller from "../utilities/Scroller";

export default {
  props: ["content", "active"],
  components: {
    Scroller
  },
  data() {
    return {
      index: 0,
      progress: 0,
      offset: 0,
      direction: "foreward",
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {
    currentContent() {
      return this.content[this.index];
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
.chapter-preview-component {
  background: #fff;
}
.fake-section {
  width: 100vw;
  height: 100vh;
}
.background {
  width: 100%;
  height: 100vh;
}

.chapter-preview {
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  width: 100vw;
  font-family: "Avenir Next";
  .chapter-preview-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    &::after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-image: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.9) 0%,
        transparent 100%
      );
    }
    &.chapter-enter-active,
    &.chapter-leave-active {
      transition: opacity 1.5s ease;
      .chapter-preview-caption span,
      .chapter-preview-title,
      .chapter-preview-icon {
        transition: all 0.5s ease;
      }
      .chapter-preview-index,
      .bullet-left div,
      .bullet-right div {
        transition: all 1s ease;
      }
      .leggi {
        transition: all 1.5s ease;
        cursor: pointer;
      }
    }
    // Enter both
    &.chapter-enter,
    &.chapter-leave-to {
      opacity: 0;
    }
    // Enter Foreward
    &.chapter-enter.foreward {
      .chapter-preview-title,
      .chapter-preview-index,
      .chapter-preview-caption span,
      .bullet-left div,
      .bullet-right div {
        transform: translateY(-100px);
        opacity: 0;
      }
      .chapter-preview-icon {
        transform: translateY(-20px);
        opacity: 0;
      }
      .leggi {
        opacity: 0;
        transform: translateX(-40px);
      }
    }
    // Enter Backward
    &.chapter-enter.backward {
      .chapter-preview-title,
      .chapter-preview-index,
      .chapter-preview-caption span,
      .bullet-left div,
      .bullet-right div {
        transform: translateY(100px);
        opacity: 0;
      }
      .chapter-preview-icon {
        transform: translateY(20px);
        opacity: 0;
      }
      .leggi {
        opacity: 0;
        transform: translateX(-40px);
      }
    }

    // Leave Foreward
    &.chapter-leave-to.foreward {
      .chapter-preview-title,
      .chapter-preview-index,
      .chapter-preview-caption span,
      .bullet-left div,
      .bullet-right div {
        transform: translateY(100px);
        opacity: 0;
      }
      .chapter-preview-icon {
        transform: translateY(20px);
        opacity: 0;
      }
      .leggi {
        opacity: 0;
        transform: translateX(40px);
      }
    }
    // Leave Backward
    &.chapter-leave-to.backward {
      .chapter-preview-title,
      .chapter-preview-index,
      .chapter-preview-caption span,
      .bullet-left div,
      .bullet-right div {
        transform: translateY(-100px);
        opacity: 0;
      }
      .chapter-preview-icon {
        transform: translateY(-20px);
        opacity: 0;
      }
      .leggi {
        opacity: 0;
        transform: translateX(40px);
      }
    }
    .chapter-preview-image {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .dida {
      position: absolute;
      bottom: 30px;
      right: 50px;
      text-align: right;
      color: white;
      font-size: 14px;
      text-shadow: 1px 1px rgba(0, 0, 0, 0.9);
      opacity: 0.5;
    }
    .chapter-preview-content {
      max-width: 1280px;
      width: 100%;
      color: white;
      position: relative;
      padding-left: 5em;
      z-index: 1;
      .leggi {
        font-size: 0.8rem;
        position: relative;
        left: -54px;
        text-transform: capitalize;
        margin-top: 34px;
        display: flex;
        align-items: center;

        a {
          font-size: 1rem;
          color: white;
          text-decoration: unset;
          display: flex;
          align-items: center;
          transition: all 0.3s ease;
          .freccia {
            height: 40px;
            width: 40px;
            border: solid 1px $eni-yellow;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 20px;
            transition: all 0.3s ease;
            .svg-icon {
              stroke: $eni-yellow;
              stroke-width: 1px;
              fill: none;
            }
          }
          &:hover {
            .freccia {
              transform: translateX(5px);
              background: $eni-yellow;
              .svg-icon {
                stroke: black;
              }
            }
          }
        }
      }
      .chapter-preview {
        &-index {
          font-size: 20rem;
          font-family: "Avenir Next";
          font-weight: 900;
          position: absolute;
          top: 0;
          left: -40px;
          line-height: 15rem;
          opacity: 0.2;
        }
        &-title {
          font-weight: 800;
          margin-bottom: 1em;
          text-transform: uppercase;
          color: #fff;
          span {
            padding-right: 0.5em;
            margin-right: 0.4em;
            border-right: 1px solid $eni-yellow;
          }
        }
        &-caption {
          font-size: 3em;
          font-weight: 800;
          max-width: 650px;
          margin-bottom: 0.5em;
          color: #fff;
          & span {
            display: inline-block;
          }
        }
        &-bullets {
          font-size: 1.125rem;
          position: relative;

          .svg-icon {
            fill: none;
            stroke: white;
            position: absolute;
            left: -60px;
            bottom: 12px;
          }
          .bullet-left {
            display: inline-flex;
            flex-direction: column;
            div {
              border-right: 1px solid $eni-yellow;
              padding-right: 15px;
              margin: 6px;
              margin-bottom: 2px;
            }
          }
          .bullet-right {
            display: inline-flex;
            flex-direction: column;
            text-transform: uppercase;
            div {
              margin: 6px;
              margin-bottom: 2px;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1400px) {
  .chapter-preview {
    .chapter-preview-wrapper {
      .chapter-preview-content {
        padding-left: 8em;
        padding-top: 5em;
        .chapter-preview {
          &-index {
            left: 15px;
            top: 70px;
          }
        }
      }
    }
  }
}
@media (max-width: 1023px) {
  .chapter-preview {
    background: black;
    .chapter-preview-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 50px 0 70px 0;
      position: relative;
      z-index: 1;
      &::after {
        background: unset;
      }
      .chapter-preview-image {
        background-repeat: no-repeat;
        background-size: 130% !important;
        background-position: 100% 50% !important;
        width: 100vw;
        height: 60vh;
        z-index: 2;
        &::after {
          content: "";
          position: absolute;
          bottom: 0px;
          left: 0;
          height: 100%;
          width: 100%;
          background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0) 50%,
            rgba(0, 0, 0, 0.5) 80%,
            rgba(0, 0, 0, 1) 90%,
            rgba(0, 0, 0, 1) 100%
          );
        }
      }
      .chapter-preview-content {
        z-index: 3;
        max-width: 900px;
        width: 85%;
        .chapter-preview {
          &-index {
            left: -25px;
          }
          &-caption {
            font-size: 2.8em;
          }
        }
      }
    }
  }
}
@media (max-width: 720px) {
  .background {
    height: calc(100vh - 48px);
    margin-top: 48px;
  }
  .chapter-preview {
    background: black;
    .chapter-preview-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 50px 0 70px 0;
      position: relative;
      &::after {
        background: unset;
      }
      .chapter-preview-image {
        background-repeat: no-repeat;
        background-size: cover !important;
        background-position: 50% 100% !important;
        width: 100vw;
        height: 400px;
        z-index: 3;
        &::after {
          content: "";
          position: absolute;
          bottom: -10px;
          left: 0;
          height: 100%;
          width: 100%;
          background: none;
        }
      }

      .chapter-preview-content {
        max-width: 900px;
        width: 85%;
        padding-left: 20px;

        .leggi {
          left: 0px;
        }
        .chapter-preview {
          &-index {
            display: none;
          }
          &-title span {
            // font-size: 20px;
          }
          &-caption {
            font-size: 16px;
            font-weight: 500;
            line-height: 20px;
            margin-bottom: 0em;
            padding-left: 40px;
          }
          &-bullets {
            .bullet-left,
            .bullet-right {
              display: none;
            }
            .svg-icon {
              height: 50px !important;
              fill: none;
              stroke: white;
              position: absolute;
              left: -5px;
              bottom: 5px;
            }
          }
        }
      }
    }
  }
}
</style>


